import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";
import { Update_To_MongoDB_By_ID } from "../../api/Update_To_MongoDB_By_ID";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Get_limited_Choose_Fields_With_Sort_From_MongoDB } from "../../api/Get_limited_Choose_Fields_With_Sort_From_MongoDB";
import { Post_To_MongoDB } from "../../api/Post_To_MongoDB";
import { StaffuseAuth } from "../../security/StaffuseAuth";

function AdminUpdates() {
  const { logout } = StaffuseAuth();
  //The below is the state for the form
  const [AdminUpdates, setAdminUpdates] = useState([]);

  useEffect(() => {
    Get_limited_Choose_Fields_With_Sort_From_MongoDB(
      "AdminInfo",
      "Updates",
      10000,
      { DateTime: -1 },
      setAdminUpdates,
      {},
      logout
    );
  }, []);

  const [newAdminUpdate, setnewAdminUpdate] = useState({
    DateTime: new Date().toISOString(),
    Note: "",
  });

  const handlenewAdminUpdateChange = (prop) => (event) => {
    setnewAdminUpdate({ ...newAdminUpdate, Note: event.target.value });
  };

  //The below is the state for the Submit button
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    Post_To_MongoDB(
      newAdminUpdate,
      "AdminInfo",
      "Updates",
      setIsSubmitting,
      logout
    );
    setnewAdminUpdate({
      DateTime: new Date().toISOString(),
      Note: "",
    });
  };

  return (
    <div style={{ backgroundColor: "#e5e5e5" }}>
      {" "}
      <div
        name="space"
        style={{ width: "100%", height: "20px", flex: "0 1 auto" }}
      ></div>
      <Container maxWidth="m">
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            margin: "0 auto",
            maxHeight: 400,
            overflow: "auto",
          }}
        >
          <Table
            aria-label="simple table"
            sx={{
              border: "1px solid #e0e0e0",
              tableLayout: "fixed",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  className="tableCellHeader" // Add this line to include the CSS class
                  align="left"
                  style={{
                    position: "sticky",
                    Top: 0,
                    zIndex: 1,
                    fontWeight: "bold", // Make Text bold
                    padding: "8px", // Adjust padding as needed To make cells smaller
                    width: "10%",
                  }}
                >
                  DateTime
                </TableCell>
                <TableCell
                  className="tableCellHeader" // Add this line to include the CSS class
                  align="left"
                  style={{
                    position: "sticky",
                    Top: 0,
                    zIndex: 1,
                    fontWeight: "bold", // Make Text bold
                    padding: "8px", // Adjust padding as needed To make cells smaller
                  }}
                >
                  Note
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {AdminUpdates && Array.isArray(AdminUpdates) ? (
                AdminUpdates.map((AdminUpdate, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {AdminUpdate.DateTime.substring(0, 10)}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {AdminUpdate.Note}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <></>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* if you are an admin */}
        {localStorage.getItem("Username") === "curtis@investin.org" ? (
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "100%" },
            }}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <TextField
              required
              id="newAdminUpdate_Note"
              label="newAdminUpdate_Note"
              value={newAdminUpdate.Note}
              onChange={handlenewAdminUpdateChange("Note")}
              multiline
              rows={5}
            />

            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, ml: 1 }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </Box>
        ) : (
          <></>
        )}

        <br></br>
      </Container>
    </div>
  );
}

export default AdminUpdates;
